import { render, staticRenderFns } from "./GameFilterButton.vue?vue&type=template&id=6a3ff0d0&scoped=true"
import script from "./GameFilterButton.vue?vue&type=script&lang=js"
export * from "./GameFilterButton.vue?vue&type=script&lang=js"
import style0 from "./GameFilterButton.vue?vue&type=style&index=0&id=6a3ff0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3ff0d0",
  null
  
)

export default component.exports